import { api } from './api';

export interface CommentAuthor {
  name: string | null;
  email: string | null;
  pictureUrl: string | null;
}

export interface Comment {
  id: string;
  workspaceId: string;
  targetKind: string;
  targetId: string;
  userId: string | null;
  author: CommentAuthor;
  body: string;
  mentions: string[];
  createdAt: string;
}

export const commentsApi = {
  async list(workspaceId: string, targetKind: string, targetId: string): Promise<Comment[]> {
    const r = await api.get<Comment[]>(`/api/workspaces/${workspaceId}/comments`, {
      params: { targetKind, targetId },
    });
    return r.data;
  },
  async create(
    workspaceId: string,
    body: { targetKind: string; targetId: string; body: string; mentions?: string[] },
  ): Promise<Comment> {
    const r = await api.post<Comment>(`/api/workspaces/${workspaceId}/comments`, body);
    return r.data;
  },
};
